// extracted by mini-css-extract-plugin
module.exports = {"main_color":"#009ccc","container":"RightColumn-module--container--twRap","content":"RightColumn-module--content--3lbn5"};